import gql from 'graphql-tag';

// Schemas
const comparisonSchema = `
id
type
division
name
model
msrp
price
imageUrl
specUrl
maximumBph
maximumWorkingHeight
minimumHorsePower
`;

const sellingToolSchema = `
id
type
division
name
model
msrp
price
imageUrl
specUrl
videoUrl
featureUrl
specBullets
salesHighlights
rebates
tcoUrl
productTourUrl
lengthCalculatorUrl
dealerPCode
dealerSalesCode
productSignifier
productSignifierExpiryDate
`;

// Queries
export const productComparisonGroups = gql`
  query {
    getProductComparisonGroups {
      key
      value
      options {
        key
        value
      }
    }
  }
`;

export const productComparisons = gql`
query ($options: [ComparisonGroupInput]!){
  getProductComparisons(options: $options) {
    products {
      ... on GrainHandlingProduct {
        ${comparisonSchema}
      }
    }
    upsells {
      ... on GrainHandlingProduct {
        ${comparisonSchema}
        upsellBanner
      }
    }
  }
}`;

export const sellingToolGroups = gql`
  query {
    getSellingToolGroups {
      key
      value
      options {
        key
        value
      }
    }
  }
`;

export const productSellingTool = gql`
query ($options: [ComparisonGroupInput]!){
  getSellingToolResults(options: $options) {
    products {
      ... on GrainHandlingProduct {
        ${sellingToolSchema}
      }
    }
    upsells {
      ... on GrainHandlingProduct {
        ${sellingToolSchema}
        upsellBanner
      }
    }
  }
}`;

export const getLastUpdated = gql`
  query {
    lastUpdated
  }
`;

export const getUserInfo = gql`
  query {
    getUserInfo {
      userId
      email
      givenName
      lastName
      phone
      country
      visitCount
      lastVisit
      shouldShowCompareTools
      tools {
        brochures
        dealerSuccess
        learning
        logos
        manuals
        parts
        productRegistration
        selling
        warrantyClaims
      }
      dealer {
        id
        name
        address
        city
        province
        postalCode
        country
        phone
        dealerGroup {
          id
          name
        }
        agiReps {
          id
          givenName
          lastName
          email
          phone
          createdAt
          updatedAt
        }
      }
      brands
      primaryAddress {
        isDirect
        street
        city
        state
        stateCode
        postalCodeString
        phoneString
      }
    }
  }
`;

export const productNews = gql`
  query {
    getNews {
      id
      name
      imageUrl
      newsLink
      newsDescription
      updated
    }
  }
`;

export const getDivisions = gql`
  query {
    getDivisions {
      id
      name
      pricingQuery
    }
  }
`;

export const getBrands = gql`
  query {
    getBrands {
      id
      name
      partsUrl
      farmBrand
    }
  }
`;

export const getLandingPage = gql`
  query {
    getLandingPage {
      announcements {
        id
        title
        body
        link
        backgroundImage
        teaser
        leadImage
        ctaText
        ctaType
        createdAt
      }
      carousel {
        id
        body
        backgroundImage
        mobileBackground
        ctaText
        ctaLink
        justLaunched
      }
      bottomPromo {
        id
        title
        body
        backgroundImage
        mobileBackground
        ctaText
        ctaLink
        ctaType
        alignment
        bannerText
      }
    }
  }
`;

export const getAnnouncements = gql`
  query {
    getAnnouncements {
      id
      title
      body
      link
      backgroundImage
      leadImage
      ctaText
      ctaType
      createdAt
      teaser
    }
  }
`;

/**
 * @param String - expecting `Storm`, `Batco`, `Westfield`, `Rem`, `Wheatheart` so far
 */
const getPricingSchema = brand => {
  switch (brand) {
    case 'getStormPricing':
      return `
        series
        size
        length
        driveType
        hopper
        powerSwing
        moverKitBundle
        steelIntakeHopper
        wheelKit
        reducerReverserKit
      `;
    case 'getBatcoPricing':
      return `
        productType
        series
        length
        driveType
        driveOption
        railcarUnloader
        powerSwing
        fmdBundle
        engineMount
        towPackage
        extensionKit
      `;
    case 'getRemPricing':
      return `
        series
        dustCollector
      `;
    case 'getWheatheartPricing':
      return `
        productType
        series
        size
        length
        driveType
        driveOption
        hopper
        powerSwing
        moverKitBundle
        steelIntakeHopper
        reducerReverserKit
        plusModel
        skidSteeror3PtHitch
        selfContainedHydraulicKit
      `;
    case 'getWestfieldPricing':
      return `
        productType
        series
        length
        driveType
        driveOption
        hopper
        powerSwing
        moverKitBundle
        engineMount
        steelIntakeHopper
        wheelKit
        extensionKit
        reducerReverserKit
      `;
    case 'getAgiPricing':
      return `
        productType
        series
        length
        driveType
        driveOption
        hopper
        powerSwing
        moverKitBundle
        engineMount
        steelIntakeHopper
        wheelKit
        extensionKit
        reducerReverserKit
      `;
    case 'getHutchinsonPricing':
      return `
        productType
        series
        size
        length
        driveType
        driveOption
        hopper
        winch
        powerSwing
        headSpouts
        moverKitBundle
        engineMount
        steelIntakeHopper
        reducerReverserKit
      `;
    default:
      return '';
  }
};

export const getPricing = brand => {
  return gql`
    query {
      ${brand} {
        brand
        ${getPricingSchema(brand)}
        currency
        netPrice
        price
        updatedAt
      }
    }
  `;
};



// WEBPACK FOOTER //
// ./src/api/Queries.js